import { Link } from "react-router-dom";
import Service from "../Service";
import MotionSection from "../motion/MotionSection";
import Btn from "../Btn";
import "./styles.scss";

const dataServices = [
	{
		name: "Transporte de mercancías",
		id: 1,
		url: "/contacto",
		img: "/images/services/s1.jpg",
		img_icon: "/images/services/icon_s1.png",
		description:
			"Movilizamos productos terminados, materias primas, carga seca y carga suelta con soluciones ajustadas al origen, destino y tipo de operación.",
	},
	{
		name: "Transporte de consolidados",
		id: 2,
		url: "/contacto",
		img: "/images/services/s2.jpg",
		img_icon: "/images/services/icon_s2.png",
		description:
			"Gestionamos cupos completos y consolidación hacia y desde los principales puertos del país.",
	},
	{
		name: "Transporte de contenedores",
		id: 3,
		url: "/contacto",
		img: "/images/services/s3.jpg",
		img_icon: "/images/services/icon_s3.png",
		description:
			"Transportamos contenedores de 20 y 40 pies desde puertos principales hacia el interior y desde el interior hacia puerto.",
	},
	{
		name: "Transporte de última milla",
		id: 4,
		url: "/contacto",
		img: "/images/services/s4.jpg",
		img_icon: "/images/services/icon_s4.png",
		description:
			"Atendemos distribución urbana y municipal con enfoque en cumplimiento, trazabilidad y adaptación a restricciones locales.",
	},
	{
		name: "Operaciones in house",
		id: 5,
		url: "/contacto",
		img: "/images/services/s5.jpg",
		img_icon: "/images/services/icon_s5.png",
		description:
			"Integramos equipo operativo dentro de las instalaciones del cliente para responder con mayor cercanía y conocimiento del proceso.",
	},
	{
		name: "Administración de flotas",
		id: 6,
		url: "/contacto",
		img: "/images/services/s6.jpg",
		img_icon: "/images/services/icon_s6.png",
		description:
			"Analizamos operaciones con flota propia, optimizamos corredores y apoyamos la administración de costos y personal.",
	},
];

const Services = () => {
	return (
		<section className="servicesCont">
			<header className="servicios_header">
				<span>SERVICIOS / OPERACIÓN NACIONAL</span>
				<h1>Soluciones de transporte para carga, puertos y distribución.</h1>
				<p>
					Elige el servicio que más se acerca a tu operación. Si tu necesidad requiere una ruta o modalidad especial,
					nuestro equipo puede orientarte.
				</p>
			</header>

			{dataServices.map((service) => (
				<MotionSection key={service.id} as="div" className="service_motion">
					<Service data={service} />
				</MotionSection>
			))}

			<MotionSection as="div" className="servicios_cta">
				<span>¿No ves el servicio que necesitas?</span>
				<h2>Cuéntanos tu operación y revisamos la mejor alternativa.</h2>
				<Link to="/contacto">
					<Btn type="btn_2">Contáctanos</Btn>
				</Link>
			</MotionSection>
		</section>
	);
};

export default Services;
